import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: 'input[decimalInput]'
})
export class DecimalNumberDirective {
  constructor(
    private el: ElementRef<HTMLInputElement>,
    private control: NgControl
  ) {
    // Ensure we have text type and decimal keyboard
    this.el.nativeElement.type = 'text';
    this.el.nativeElement.inputMode = 'decimal';
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    if (!value) {
      if (this.control?.control) {
        this.control.control.setValue(null, { emitEvent: false });
      }
      return;
    }

    // Convert comma to dot
    const numericValue = value.replace(',', '.');
    
    // Only parse if we have a complete number (no trailing decimal point)
    if (!numericValue.endsWith('.')) {
      const numValue = parseFloat(numericValue);
      
      if (!isNaN(numValue)) {
        if (this.control?.control) {
          this.control.control.setValue(numValue, { emitEvent: false });
        }
      }
    } else {
      // For incomplete decimals, just update the form control with the string value
      if (this.control?.control) {
        this.control.control.setValue(numericValue, { emitEvent: false });
      }
    }
  }
} 